import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { AbTestsService } from "../services/ab-tests.service";
import { AbTest } from "../ab-tests.interfaces";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-ab-tests-list',
  templateUrl: './ab-tests-list.component.html',
  styleUrls: ['./ab-tests-list.component.css'],
})
export class AbTestsListComponent implements OnInit, OnDestroy {
  public breadcrumb: string[] = [];
  public items: AbTest[] = [];
  public loading: boolean;

  constructor(
    private router: Router,
    private service: AbTestsService,
    private titleService: Title
  ) {
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`AB Tests | CODE Hospitality CMS`);
    this.loadItems();
    this.breadcrumb = ["AB Tests"];
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadItems() {
    this.loading = true;
    this.service.getAllAbTests().subscribe(
      (res) => {
        this.items = res.json();
        this.loading = false;
      },
      (err) => {
        alertify.error(err);
        this.loading = false;
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }

  private split(item: AbTest) {
    return `${item.split}/${100 - item.split}`;
  }

  private edit(item: AbTest) {
    this.router.navigate(['/admin/ab-tests/edit'], { queryParams: { id: item.id } });
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/ab-tests/ab-tests-list/ab-tests-list.component.ts